<template>
	<div class="app-layout">
		<AppHeader />

		<main id="main" class="app-main">
			<div class="app-main-content">
				<slot />
			</div>
		</main>

		<AppFooter />
	</div>
</template>

<script setup lang="ts">
import AppFooter from './AppFooter.vue'
import AppHeader from './AppHeader.vue'
</script>

<style scoped>
h1 {
	font: var(--type-headline-m);
}

.app-main {
	align-content: center;
	display: flex;
	justify-content: center;
	max-inline-size: 100vw;
	padding-block: var(--size-40);
	padding-inline: var(--app-edge-spacing);
}

.app-layout {
	display: grid;
	grid-template-rows: min-content 1fr min-content;
	min-block-size: 100vh;
}

.app-main-content {
	inline-size: min(68rem, 100%);
}

.app-greeting {
	font: var(--type-headline-title);
	text-align: center;
}

@media print {
	.app-header,
	.app-footer {
		display: none !important;
	}
}
</style>
